import React from "react";

interface Props {
  content?: string | null;
  children: React.ReactNode;
}

export const PaymentMethodActionTooltip: React.FC<Props> = ({
  content,
  children,
}) => {
  if (!content) {
    return <>{children}</>;
  }

  return (
    <span className="payment-method-action-tooltip" tabIndex={0}>
      {children}
      <span className="payment-method-action-tooltip__content" role="tooltip">
        {content}
      </span>
    </span>
  );
};
